import baseReport from './baseReport';
import moment from 'moment'


const comprovanteInscricao = async (dados) => {

    const date = moment().format('DD/MM/YYYY')
    const time = moment().format('HH:mm:ss')

    const headerFooter = await baseReport({ date, time, title: 'Comprovante de Inscrição Distribuição de Aulas online', subTitle: dados.dstpcargo });

    const filtrosFormated = [
        {
            text: 'Ano letivo: ' + dados.dadosDaInscricao.aaletivo
        }

    ]

    const dataFormated = [
        {
            text: 'A inscrição de ' + dados.dadosFuncionario.nmfuncion.trim() + ', matrícula ' + dados.dadosFuncionario.cdpessoal + ' ' +
            dados.dadosFuncionario.cdmatric+'-'+dados.dadosFuncionario.dgmatric+', foi realizada com sucesso.',
            margin: [0, 50,0,10],
            alignment: 'justify'
        },
    ]

    const paragrafo2 = [
                              {
                                text: [
                                  {text: 'Lembrando que a inscrição é a', bold: false },
                                  {text: ' primeira fase do processo',  bold: true },
                                  {text: '. A distribuição só ocorre, de fato, depois da efetivação das aulas conforme agendamento.',  bold: false }
                                ],
                                margin: [0, 50,0,10],
                                alignment: 'justify'
                              }
                          ]
    

    return {
        ...headerFooter,
        content: [
        ...filtrosFormated,
         ...dataFormated,
         ...paragrafo2,

        ],
        styles: {
          tableHeader: {
            bold: true,
            fontSize: 10,
            color: 'black',
            fillColor: '#eeeeee',
            alignment: 'center',
          },
        },
      };

}


export {comprovanteInscricao}